import { writable } from 'svelte/store';
export let switchingBetweenTabsInProgress = writable<boolean>(false);